import request from '@/utils/request'
const apiPath = '/temp/templateMaterialsShare'
import { downloadBlob } from '@/utils/download'
const templateMaterialsShareApi = {
  /**
   * 新增【模版分享物料】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【模版分享物料】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【模版分享物料】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查询【模版分享物料】选项列表
   */
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【模版分享物料】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【模版分享物料】
   */
  deleteById(data) {
    console.log("datadelete",data)
    return request.post(`${apiPath}/updateDeleteBatch`, data, { isFormData: 1 })
  },
  downloadExcelTemplate(query) {
    return request.get(`${apiPath}/downloadExcelTemplate`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '下载模板.xlsx'))
  },
  importExcel(data) {
    return request.post(apiPath + '/importExcel', data)
  },
  /**
   * 批量删除【模版分享物料】
   */
  deleteBatch(data) {
    console.log("datadeletepilliang",data)
    return request.post(`${apiPath}/updateDeleteBatch`, data, { isFormData: 1 })
  },
  /**
   * 单个修改启用状态【模版分享物料】
   */
  setIsEnable(data) {
    return request.post(`${apiPath}/updateStateBatch`, data, { isFormData: 1 })
  },
  /**
   * 批量修改启用状态【模版分享物料】
   */
  setIsEnableBatch(data) {
    return request.post(`${apiPath}/updateStateBatch`, data, { isFormData: 1 })
  },
  /**
   * 批量修改是否推荐【模版分享物料】
   */
  updateIsRecommendBatch(data) {
    return request.post(`${apiPath}/updateIsRecommendBatch`, null, { params: data })
  },
}
export default templateMaterialsShareApi
